import React from 'react';
import { PageSizeDropdown } from './PageSizeDropdown';
import { useIntl } from '@oceanjs/core';
import { FormattedMessage } from 'react-intl';

export interface PageInformationProps {
  pageIndex: number;
  pageCount: number;
  pageSize: number;
  setPageSize(size: number): any;
  pageSizes: number[];
}

export const PageInformation: React.FC<PageInformationProps> = ({ pageIndex, pageCount, pageSize, setPageSize, pageSizes }): JSX.Element | null => {
  if (pageCount == 0) {
    return null;
  }
  return (
    <React.Fragment>
      {/*
      <span className="page-text">
        {`${intl.formatMessage({id: 'datatable_pagination_page'})} ${pageIndex+1} ${intl.formatMessage({id: 'datatable_pagination_of'})} ${pageCount}`}
      </span>
       */}
      <FormattedMessage id="datatable_pagination_rows_per_page"/>
      <PageSizeDropdown pageSize={pageSize} pageSizes={pageSizes} setPageSize={setPageSize} />
    </React.Fragment>
  );

}
